import React, { useState } from 'react';
import styled from 'styled-components';
import screen1 from './screenshots/Screenshot_58.png';
import screen2 from './screenshots/Screenshot_59.png';
import screen3 from './screenshots/Screenshot_60.png';
import screen4 from './screenshots/Screenshot_62.png';
import screen5 from './screenshots/Screenshot_63.png';
import screen6 from './screenshots/Screenshot_64.png';
import PricesTable from './PricesTable';

const Details = styled.div<{ isVisible: boolean }>`
  height: ${(props) => (props.isVisible ? 'auto' : '0')};
  overflow: hidden;
  transition: 0.3s ease-in-out;
  margin: ${(props) => (props.isVisible ? '10px 0' : '0')};
`;

const Or = styled.div`
  margin: 10px;
`;

const ShortDescr = styled.div`
  color: #999;
  max-width: 300px;
  margin: 17px auto 0;
`;

const Prices = styled.div`
  margin-top: 15px;
  color: #000;
  font-weight: bold;
  color: #0093dd;
  cursor: pointer;
  display: inline-block;
  width: auto;
  position: relative;
  &:hover {
    &::after {
      width: 100%;
    }
  }
  &::after {
    content: '';
    background: #0093dd;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 0;
    width: 0;
    height: 1px;
    transition: 0.3s ease-in-out;
  }
`;

const Mask = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`;

const Screen1 = styled.img`
  position: absolute;
  z-index: 1;
  left: -179px;
  top: 40px;
  width: 600px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
`;

const Screen2 = styled.img`
  position: absolute;
  z-index: 1;
  right: 30px;
  top: 10px;
  width: 500px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
`;

const Screen3 = styled.img`
  position: absolute;
  z-index: 1;
  bottom: 20px;
  left: 10px;
  width: 500px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
`;

const Screen4 = styled.img`
  position: absolute;
  z-index: 1;
  right: 10px;
  bottom: 20px;
  top: auto;
  width: 60%;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
`;

const Screen5 = styled.img`
  position: absolute;
  z-index: 0;
  right: 627px;
  bottom: auto;
  top: 18px;
  width: 400px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
`;

const Screen6 = styled.img`
  position: absolute;
  z-index: 0;
  right: auto;
  bottom: auto;
  top: 395px;
  width: 612px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
  left: -51px;
`;

const Wrapper = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 97vh;
  text-align: center;
`;

const Title = styled.div`
  font-size: 40px;
  margin-bottom: 10px;
`;

const Description = styled.div`
  font-size: 20px;
`;

const Button = styled.div`
  display: block;
  text-decoration: none;
  color: #fff;
  border: 1px solid #fff;
  cursor: pointer;
  width: 200px;
  margin: 20px auto 10px;
  padding: 10px;
  font-size: 17px;
  transition: 0.3s ease-in-out;
  background-image: linear-gradient(to right, #1fa2ff 0%, #12d8fa 51%, #1fa2ff 100%);
  font-weight: bold;
  background-size: 200% auto;

  &:hover {
    background-position: right center;
  }
`;

const Enter = styled.div`
  color: #999;
  margin-bottom: 10px;
  span {
    border: 1px solid #999;
    display: block;
    padding: 5px;
    width: 100px;
    margin: 0 auto;
    cursor: pointer;
    transition: 0.3s ease-in-out;
    color: #000;
    font-weight: bold;
    &:hover {
      color: #0093dd;
    }
  }
`;

const Inner = styled.div`
  width: 100%;
  background: #fff;
  padding: 20px;
  display: block;
  z-index: 999;
  position: relative;
  max-width: 600px;
  border: 1px solid #fff;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.5);
`;

const LandingPage: React.FC<{ toLogin: () => void; toRegister: () => void }> = (props) => {
  const [detailsVisible, setDetailsVisible] = useState(false);

  return (
    <Wrapper>
      <Mask />
      <Inner>
        <Title>Smart Tracker</Title>
        <Description>
          Менеджер задач с функцией трекинга времени, <br /> скриншотами и статистикой
        </Description>
        <Prices onClick={() => setDetailsVisible(!detailsVisible)}>
          {detailsVisible ? 'Скрыть таблицу' : 'Подробнее о ценах'}
        </Prices>
        <Details isVisible={detailsVisible}>
          <PricesTable />
          <ShortDescr>Пробный период тарифа СТАНДАРТ - 3 дня</ShortDescr>
        </Details>
        <Button onClick={props.toRegister}>Попробовать</Button>
        <Or>или</Or>
        <Enter>
          <span onClick={props.toLogin}>Войти</span>
        </Enter>
      </Inner>
      <Screen1 src={screen1} />
      <Screen2 src={screen2} />
      <Screen3 src={screen3} />
      <Screen4 src={screen4} />
      <Screen5 src={screen6} />
      <Screen6 src={screen5} />
    </Wrapper>
  );
};

export default LandingPage;
